import "phaser";
import * as Polyglot from "node-polyglot";
import * as FontFaceObserver from "fontfaceobserver";

export const instance = new Polyglot();

export type Language = "en" | "cn" | "jp" | "kr";

export type Text = Phaser.BitmapText | Phaser.Text;

const translations: { [language: string]: any } = {
    en: require("../assets/languages/en.json"),
    cn: require("../assets/languages/cn.json"),
    jp: require("../assets/languages/jp.json"),
    kr: require("../assets/languages/kr.json"),
};

let language = "en";

export function loadFonts(): Promise<[void, void]> {
    return Promise.all([
        new FontFaceObserver("GN-Kin-iro_SansSerif").load(),
        new FontFaceObserver("Nanum Gothic").load(),
        new FontFaceObserver("HuXiaoBo_KuHei").load(),
    ]);
}

export function supports(lang: string): boolean {
    return lang == "en" || lang == "cn" || lang == "jp" || lang == "kr";
}

export function setLanguage(lang: Language) {
    instance.locale(lang);
    language = lang;
    instance.extend(translations[lang]);
}

export function getLanguage(): Language {
    const locale = instance.locale();
    if (locale) return locale as Language;
    return "en";
}

export function _(key: string, interpolation?: { [key: string]: any }) {
    if (interpolation) return instance.t(key, interpolation);
    return instance.t(key);
}

export function label(game: Phaser.Game, x: number, y: number, text: string, font: string, size: number) {
    // Fonts are also 'translated'!
    font = _(font);
    let useBitmap = language === "en";

    if (font.match(/^(vector|bitmap):/)) {
        const parsed = font.split(":");
        if (parsed[0] === "vector") {
            useBitmap = false;
        }
        font = parsed[1];
    }

    if (useBitmap) {
        return game.add.bitmapText(x, y, font, text, size);
    }
    else {
        if (language === "kr") {
            size *= 0.8;
            y += 4;
        }
        if (language === "jp") {
            size *= 1.25;
            y += size*0.2;
        }
        if (language === "cn" && size === 32) {
            size = 28;
        }
        return game.add.text(x, y, text, {
            font: font,
            fontSize: size,
            fill: "#FFFFFF",
        });
    }
}

export function wrapLabel(text: Text, width: number) {
    if (text instanceof Phaser.BitmapText) {
        text.maxWidth = width;
    }
    else {
        text.wordWrap = true;
        text.wordWrapWidth = width;
    }
}

export function labelHeight(text: Text): number {
    if (text instanceof Phaser.BitmapText) {
        return text.textHeight;
    }
    else {
        return text.height;
    }
}



// WEBPACK FOOTER //
// ./src/i18n.ts